const mode = "dev";
// let a = "../config/" + mode + ".json";
const config = require(`../config/${mode}.json`);
module.exports = {
  BASE_API: config.BASE_API
}